<template>
    <rkm-modal
        :buttons="['cancel']"
        extra-large
        ref="Modal"
        hide-header
    >
        <rkm-area
            title="Passageiros"
            type="fieldset"
            no-margin-top
        >
            <rkm-list
                :items="data"
                hide-filters
            >
                <template v-slot="{ item }">
                    <rkm-row>
                        {{ `${item.horario} ${item.municipio}/${item.estado} - ${item.nome} - ${item.destino} - ${item.ponto ?? ''}` }}
                    </rkm-row>
                    <rkm-row v-if="item.acompanhante1 || item.nome1">
                        {{ (`${item.acompanhante1 ?? item.nome1} ${item.cnsAcompanhante1 ?? ''} (${item.relacao1})`) }}
                    </rkm-row>
                    <rkm-row v-if="item.acompanhante2 || item.nome2">
                        {{ (`${item.acompanhante2 ?? item.nome2} ${item.cnsAcompanhante2 ?? ''} (${item.relacao2})`) }}
                    </rkm-row>
                    <rkm-row>
                        Endereço: {{(`${item.logradouro}, ${item.numero ?? 'Sem número'} - BAIRRO: ${item.bairro}`) }}
                    </rkm-row>
                    <rkm-row>
                        <b>Obs.:</b>{{ item.observacao }}
                    </rkm-row>
                </template>
            </rkm-list>
        </rkm-area>
    </rkm-modal>
</template>

<script>
import { repository, error } from "@/mixins"
import { mapActions } from "vuex"

export default {
    mixins: [ repository, error ],
    created() {
        this.repositories = {
            relatorioViagem: this.getConectaSusRepository('transportePaciente.relatorioViagem'),
        }
    },
    data() {
        return {
            data: []
        }
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        open(id) {
            this.setLoading()
            this.repositories.relatorioViagem.getViagem({
                viagem_id: id
            })
                .then(({ data }) => {
                    this.data = data
                    this.$refs.Modal.show()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExit() {
            this.$refs.Modal.hide()
        }
    }
}
</script>